import { render, staticRenderFns } from "./ConstructionLocation.vue?vue&type=template&id=5511634b&scoped=true&"
import script from "./ConstructionLocation.vue?vue&type=script&lang=js&"
export * from "./ConstructionLocation.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionLocation.vue?vue&type=style&index=0&id=5511634b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5511634b",
  null
  
)

export default component.exports